export default __webpack_public_path__ + "static/media/kitchen4-afterB-1920w.2ddf4b1d.avif";